<template>
    <button
        :type="type"
        class="focus:shadow-outline-red rounded-md bg-error-600 px-4 py-2 text-xs font-semibold tracking-widest text-white ease-in-out hover:bg-error-500 focus:border-error-700 active:bg-error-600 inline-flex items-center justify-center border border-transparent uppercase transition duration-150 focus:outline-none disabled:opacity-25"
    >
        <slot></slot>
    </button>
</template>

<script>
export default {
    props: {
        type: {
            type: String,
            default: "button",
        },
    },
};
</script>
